import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAppJump = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "currentColor",
	viewBox: "3.9 3.9 24.2 24.2",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M20.7132 15.5359L13.751 12.0543C13.5901 11.9743 13.3992 11.9832 13.2464 12.0777C13.0935 12.1722 13.0003 12.339 13 12.5187V19.4814C13.0003 19.6612 13.0935 19.828 13.2464 19.9225C13.3993 20.0169 13.5901 20.0256 13.751 19.9455L20.7132 16.4643C20.889 16.3763 21 16.1966 21 16.0001C21 15.8035 20.889 15.6238 20.7132 15.5359Z" }),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M19.4286 4.85714C19.4286 4.38376 19.8123 4 20.2857 4H27C27.5523 4 28 4.44771 28 5V11.7143C28 12.1877 27.6162 12.5714 27.1429 12.5714C26.6695 12.5714 26.2857 12.1877 26.2857 11.7143V6.88349L22.4993 10.6699C22.1646 11.0046 21.6219 11.0046 21.2871 10.6699C20.9524 10.3352 20.9524 9.79244 21.2871 9.45771L25.0306 5.71429H20.2857C19.8123 5.71429 19.4286 5.33053 19.4286 4.85714Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M27.1429 16C27.6162 16 28.0032 16.3851 27.9699 16.8573C27.5303 23.0846 22.3392 28 16 28C9.37258 28 4 22.6274 4 16C4 9.66082 8.91541 4.46971 15.1427 4.03015C15.6149 3.99682 16 4.38376 16 4.85714C16 5.33053 15.6149 5.71056 15.1431 5.74947C9.86339 6.18491 5.71429 10.6079 5.71429 16C5.71429 21.6806 10.3194 26.2857 16 26.2857C21.3921 26.2857 25.8151 22.1366 26.2505 16.8569C26.2894 16.3851 26.6695 16 27.1429 16Z"
		})
	]
});
export { SvgAppJump as ReactComponent };
